<template>
  <!-- 检索邻域 -->
  <div class="layer">
    <div class="retrievalField">
      <highSearch @highSearch="highSearch"></highSearch>
      <!-- 该关键词如果还有另外一种类型则显示并且可以跳转 -->
      <div class="meaning width" v-if="fieldData.typedata[0].show">
        <div class="mean width">
          {{fieldData.typedata[0].name}}是一个多义词，当前检索类型为
          <el-link type="primary" :underline="false">研究方向</el-link>，
          其他检索类型有：
          <el-link
            type="primary"
            :underline="false"
            @click="othertype"
          >{{fieldData.typedata[0].othertype === 1 ?'人名':'机构'}}</el-link>
        </div>
      </div>
      <!-- 相识关键词 -->
      <div class="search-simkeyword width" v-loading="loading4" v-if="fieldData.data.total != 0">
        <span>相似关键词:</span>
        <span
          class="simkeyword"
          v-for="(item,index) in acqKeywords"
          :key="index"
          @click="simkeySearch(item.keyCn)"
        >{{item.keyCn}}{{item.keyEn?'('+item.keyEn+')':''}}</span>
      </div>
      <!-- 主体 -->
      <div class="center width">
        <left
          :topKeywords="topKeywords"
          :topSubjects="fieldData.data.topSubjects"
          :topOrganizations="fieldData.data.topOrganizations"
          :isLeftClick="loading2"
          @screenData="getScreen"
        ></left>
        <div class="experts">
          <div class="experts-header">
            <img src="static/img/icon/user.png" />
            <span>专家检索</span>
          </div>
          <div class="search-r">
            <div class="menu clearfix">
              <h4
                v-if="!user"
              >{{intercept ? '已经为您检索到'+fieldData.data.total+'条，游客显示前100条，登录可以查看更多。':'已经为您检索到'+fieldData.data.total+'条。'}}</h4>
              <h4
                v-else
              >{{!intercept ? '已经为您检索到'+ fieldData.data.total+'条。':'已经为您检索到'+fieldData.data.total+'条，当前状态下展示为前1000条，如需更多数据请与项目组联系。'}}</h4>
              <div class="showway">
                <span>展示格式</span>
                <img @click="index=1" src="static/img/icon/nine.png" alt />
                <img @click="index=2" class="listimg" src="static/img/icon/list.png" alt />
              </div>
            </div>
            <div v-show="index===1" class="res-list clearfix" v-loading="loading2">
              <div
                class="exp-box"
                :style="{width:expWidth}"
                v-for="( item, index ) in fieldData.data.obj"
                :key="index"
              >
                <div class="exp-int clearfix">
                  <el-image
                    v-if="item.avatar || item.avatarUrl"
                    class="exp-header"
                    :src="item.avatar?item.avatar:'/old/public'+item.avatarUrl"
                    fit="contain"
                    @click="goDetail(index)"
                  >
                    <div slot="placeholder" class="image-slot" @click="goDetail(index)">
                      <img src="http://expert.ckcest.cn/autoload/images/avatar.png" />
                    </div>
                    <div slot="error" class="image-slot" @click="goDetail(index)">
                      <img src="http://expert.ckcest.cn/autoload/images/avatar.png" />
                    </div>
                  </el-image>
                  <el-image
                    @click="goDetail(index)"
                    v-else
                    class="exp-header"
                    src="http://expert.ckcest.cn/autoload/images/avatar.png"
                    fit="contain"
                  ></el-image>
                  <div class="exp-textint">
                    <h5 @click="goDetail(index)">{{item.name}} {{item.honor}}</h5>
                    <p>{{item.organization}}</p>
                    <!-- 0：机器认领  1：本人认领  2：人工认领 -->
                    <p>{{/^[0-9]+$/.test(item.kId) ? (item.claimType == 0?'机器认领':(item.claimType == 1?'本人认领':'人工认领')) : '未认领'}}</p>
                  </div>
                </div>
                <p
                  class="isni"
                  v-if="item.isni"
                >ISNI：{{item.isni.replace(/(.{4})/g,'$1-').slice(0,item.isni.length+3) }}</p>
                <p class="isni" v-else></p>
                <p
                  class="subject"
                  :title="item.subject"
                  v-if="item.subject && item.subject !== ''"
                >学科：{{item.subject}}</p>
                <p class="subject" :title="item.subject" v-else></p>
                <ul
                  class="keywords clearfix"
                  v-if="item.keyword"
                  style="background-color: #f5f5f5;"
                >
                  <li v-for="li in item.keywordList" :key="li">{{li}}</li>
                </ul>
                <ul class="keywords clearfix" v-else></ul>
              </div>
            </div>
            <div v-show="index===2" class="res-listelse" v-loading="loading2">
              <ul>
                <li class="clearfix" v-for="( item, index ) in fieldData.data.obj" :key="index">
                  <div class="eles-info">
                    <div class="else-header">
                      <el-image
                        @click="goDetail(index)"
                        class="exp-header"
                        :src="  item.avatar?item.avatar:'/old/public'+item.avatarUrl"
                        fit="contain"
                      >
                        <div slot="placeholder" class="image-slot">
                          <img
                            width="100%"
                            height="100%"
                            src="http://expert.ckcest.cn/autoload/images/avatar.png"
                          />
                        </div>
                        <div slot="error" class="image-slot">
                          <img
                            width="100%"
                            height="100%"
                            src="http://expert.ckcest.cn/autoload/images/avatar.png"
                          />
                        </div>
                      </el-image>
                    </div>
                    <div class="else-int">
                      <h5
                        @click="goDetail(index)"
                        style="color:#879b86"
                      >{{item.name}} {{item.honor}}</h5>

                      <p style="color:#879b86" :title="item.organization">{{item.organization}}</p>
                      <!-- <p>认领人：中国工程院院士馆</p> -->
                      <p>{{/^[0-9]+$/.test(item.kId) ? (item.claimType == 0?'机器认领':(item.claimType == 1?'本人认领':'人工认领')) : '未认领'}}</p>
                      <p
                        v-if="item.isni"
                      >ISNI：{{item.isni.replace(/(.{4})/g,'$1-').slice(0,item.isni.length+3) }}</p>
                      <p style="min-height:20px" v-else></p>
                      <p
                        class="subject"
                        :title="item.subject"
                        v-if="item.subject && item.subject !== ''"
                      >学科：{{item.subject}}</p>
                      <p class="subject" :title="item.subject" v-else></p>
                      <div class="else-keywords" v-if="item.keyword">
                        <span>研究方向：</span>
                        <a v-for="li in item.keywordList" :key="li">{{li}}</a>
                      </div>
                      <div class="else-keywords" v-else></div>
                    </div>
                    <ul class="elseinttext">
                      <li
                        v-if="item.introduction"
                        class="elseinttext-item"
                      >{{item.introduction.trim() }}</li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <pagination
            :pageSizes="pageSizes"
            :total="user?(fieldData.data.total>1200?1200:fieldData.data.total):(fieldData.data.total>120?120:fieldData.data.total)"
            :page.sync="pageData.PageIndex"
            :limit.sync="pageData.PageSize"
            :layout="layout"
            @pagination="getPage()"
          />
          <p class="cup" @click="showUs" style="text-align:right;padding-right:30px">如需获取更多专家信息欢迎和我们联系</p>
        </div>
      </div>
      <!-- 关键词信息 -->
      <div class="info width" v-if="keyTr && fieldData.data.total != 0">
        <div class="info-header">
          <span>{{fieldData.typedata[0].name}}</span>
          <span style="margin:0 30px">{{keyTr}}</span>
        </div>
        <div class="info-details" v-loading="loading1">
          <div class="info-chart">
            <LineMaxMinChart
              v-if="Object.keys(historyList).length"
              style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
              class="line"
              id="HOTChart"
              height="100%"
              width="100%"
              :LineMaxMinList="historyList"
            />
            <div v-else style="display:flex;;height: 100%;">
              <span style="margin:auto;font-size: 20px;" v-if="!loading1">暂无该关键词历史热度</span>
            </div>
          </div>

          <div class="info-chart" v-loading="loading3">
            <wordcloud-Chart
              v-if="Object.keys(simkeywordsList).length"
              style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
              :WordCloudList="simkeywordsList"
              id="CNChart"
              height="100%"
              width="100%"
              tit="中文关联关键词"
              :isClick="isClick"
            />
            <div v-else style="display:flex;height: 100%;">
              <span style="margin:auto;font-size: 20px;" v-if="!loading1">暂无该关键词中文关联领域</span>
            </div>
          </div>

          <div class="info-chart" v-loading="loading3">
            <wordcloud-Chart
              v-if="Object.keys(keyEnCList).length"
              style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
              :WordCloudList="keyEnCList"
              id="CNChart"
              height="100%"
              width="100%"
              tit="英文关联关键词"
              :isClick="isClick"
            />
            <div v-else style="display:flex;height: 100%;">
              <span style="margin:auto;font-size: 20px;width:100%" v-if="!loading3">暂无该关键词英文关联领域</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import highSearch from '@/components/common//highSearch'
import left from '@/components/commonrRetrieve/left'
import Chart from '@/components/Charts/LineMarker'
import LineMaxMinChart from '@/components/Charts/LineMaxMinChart'
import PieChart from '@/components/Charts/PieChart'
import { getBase64Avatar } from '@/api/center'
import WordcloudChart from '@/components/Charts/WordcloudChart'
import { checkReplacePath } from '@/utils/index'
import {
  searchCoreKeywordsv2,
  getKeywordTranslate,
  getKeywordAnalysis
} from '@/api/retrieveField'
import { search } from '@/api/common'

export default {
  name: 'RetrieveField',
  props: {},
  watch: {
    index: {
      deep: true,
      handler (val) {
        if (val === 2) {
          this.pageData.PageSize = 3
          this.pageData.PageIndex = this.pageIndex2
          this.pageSizes = [3]
        } else {
          this.pageData.PageSize = 20
          this.pageData.PageIndex = this.pageIndex1
          this.pageSizes = [20]
        }
        this.getPage()
      }
    },
    screenWidth: function (val) {
      this.changeExpWidth(val)
    }
  },
  components: {
    Pagination,
    highSearch,
    left,
    Chart,
    LineMaxMinChart,
    PieChart,
    WordcloudChart
  },
  data () {
    let _this = this
    return {
      fieldData:
        _this.$route.params.data === undefined
          ? JSON.parse(localStorage.getItem('fieldData'))
          : this.$route.params.data, // 传入的参数
      user: localStorage.getItem('user'), // tid
      keyTr: '', // 关键词翻译
      keyCn: '', // 中文
      isClick: true, // 词云图是否有点击事件
      /* 分页 */
      layout: 'prev, pager, next, jumper', // 分页
      pageData: {
        No: '',
        Name: '',
        PageSize: 20,
        PageIndex: 0
      }, // 分页情况
      pageSizes: [20], // 每页条数
      fieldDataParams: JSON.parse(localStorage.getItem('fieldDataParams')),
      intercept: false, // 检索到条数文字
      index: 1, //  当前布局
      pageIndex2: 0, // 密集布局当前页面
      pageIndex1: 0, // 当行布局当前页面
      loading1: false, // 加载动画1
      loading2: false, // 加载动画2
      loading3: false, // 加载动画3
      loading4: false, // 加载动画3
      screenData: {}, // 左侧栏返回数据
      keywordList: [], // 关键词数组
      simkeywordsList: [], // 相识关键词数组图表
      acqKeywords: [],
      historyList: [], // 历史热度数组
      // keyEnList: [], // 关键词英文数组（传入左侧栏）
      keyEnCList: [], // 关键词英文数组（Eacher）
      k: '',
      topKeywords: [], // 研究主题
      expWidth: '23%', // 专家信息宽度
      screenWidth: document.documentElement.clientWidth // 屏幕宽度
    }
  },
  mounted () {
    var _this = this
    this.changeExpWidth(this.screenWidth)
    window.onresize = function () {
      // 定义窗口大小变更通知事件
      _this.screenWidth = document.documentElement.clientWidth // 窗口宽度
    }
    localStorage.setItem('fieldData', JSON.stringify(this.fieldData)) // 将信息保存到 localStorage
    this.fieldData.data.obj = this.fieldData.data.obj
    this.fieldDataParams = { k: this.fieldData.typedata[0].name }
    // this.keys();
    this.init()
  },
  methods: {
    showUs () {
      this.$store.commit('ContactUs', true)
    },
    init () {
      this.topKeywords = []
      this.loading1 = true
      let data1 = {
        k: this.fieldData.typedata[0].name
      }
      let data2 = {
        e: true,
        k: this.fieldData.typedata[0].name,
        s: 'desc'
      }
      this.loading3 = true
      this.loading4 = true
      //  获取中英文关联关键词
      if (!this.fieldData.typedata[0].name) {
        return
      }

      searchCoreKeywordsv2({ keyword: this.fieldData.typedata[0].name }).then(
        res => {
          this.simkeywordsList = []
          res.data.data.cnkeyword &&
            res.data.data.cnkeyword.forEach((item, index) => {
              let temp = {
                name: item.key,
                count: item.doc_count
              }
              this.simkeywordsList.push(temp)
            })
          if (this.simkeywordsList.length) {
            this.translation()
          } else {
            this.loading4 = false
          }
          this.keyEnCList = []
          res.data.data.enkeyword &&
            res.data.data.enkeyword.forEach((item, index) => {
              let temp = {
                name: item.key,
                count: item.doc_count
              }
              this.keyEnCList.push(temp)
            })
          this.loading3 = false
        }
      )
      // 获取翻译
      getKeywordTranslate(data1)
        .then(res => {
          var pattern = new RegExp('[\u4E00-\u9FA5]+')
          this.keyCn = res.data.data[0].keyCn
          this.keyTr = pattern.test(this.fieldData.typedata[0].name)
            ? res.data.data[0].keyEn
            : res.data.data[0].keyCn
        })
        .catch(err => {
          console.log(err)
        })
      // 获取历史热度
      getKeywordAnalysis(data2)
        .then(res => {
          this.loading1 = false
          // this.loading1 = false
          this.historyList = res.data.years.slice(0, res.data.years.length - 1)
        })
        .catch(err => {
          console.log(err)
        })

      this.key(0) // 获取研究主题
      this.searchtype = this.fieldData.searchtype
    },
    async highSearch (params) {
      console.log(params)
      await this.getPage(params, true) // 第二个参数是重置分页
      this.init()
    },
    setAvatar (item) {
      return new Promise(resolve => {
        if (!isNaN(item.kId)) {
          getBase64Avatar({ kId: item.kId }).then(res => {
            resolve(
              res.data[0].data[0] && res.data[0].data[0].avatar
                ? res.data[0].data[0].avatar.replace(/[\r\n]/g, '')
                : ''
            )
          })
        }
      })
    },
    /* 根据页面宽度进行跳转专家宽度 */
    changeExpWidth (val) {
      if (val > 1480) {
        this.expWidth = '23%'
      } else if (val > 980) {
        this.expWidth = '32%'
      }
    },
    /* 获取研究主题
     * 研究主题又专家列表中的keyword组成
     * 判断第一个人的keyword个数是否大于10
     * 如果大于则研究主题等于这个人的keyword的前10
     * 反之加上下一个人的keyword
     */
    key (index) {
      this.topKeywords = []
      if (
        this.fieldData.data.obj[index] &&
        this.fieldData.data.obj[index].keyword
      ) {
        this.topKeywords = this.topKeywords.concat(
          this.fieldData.data.obj[index].keywordList ||
            this.fieldData.data.obj[index].keyword.split(';') ||
            []
        )
      } else {
        this.topKeywords = this.topKeywords.concat({})
      }
      if (this.topKeywords.length > 10) {
        this.keys()
      } else {
        this.key(index + 1)
      }
    },
    // 研究主题赋值
    keys () {
      let temp = this.fieldData.data.topKeywords || this.topKeywords
      let data = []
      temp.forEach((item, index) => {
        if (index > 9) {
          return
        }
        data.push({
          key: item.key || item
        })
      })

      this.topKeywords = data
    },
    // 左侧点击事件
    getScreen (data) {
      this.screenData = data
      this.pageData.PageIndex = 0
      let par = {}
      if (sessionStorage.getItem('highSearch')) {
        par = JSON.parse(sessionStorage.getItem('highSearch'))
      }
      this.getPage(par)
    },
    // 获取新的专家列表数据
    async getPage (par = this.fieldDataParams, rest = false) {
      this.setTip()
      this.loading2 = true
      let index =
        this.pageData.PageIndex - 1 > 0 ? this.pageData.PageIndex - 1 : 0
      if (rest) {
        this.pageData.PageIndex = 1
        index = 0
      }
      let data = {
        k: this.fieldData.typedata[0].name,
        ...par,
        from: index * this.pageData.PageSize,
        size: this.pageData.PageSize,
        ...this.screenData
      }

      if (data.next) {
        data.para = this.fieldData.data.query
      }
      if (!par.k) {
        delete data.k
      }
      // if (this.searchtype === 0 || this.searchtype) {
      //   let temp = {
      //     searchtype: this.searchtype
      //   }
      //   data = Object.assign(data, temp)
      // }
      if (this.index === 1) {
        this.pageIndex1 = this.pageData.PageIndex
      } else {
        this.pageIndex2 = this.pageData.PageIndex
      }
      if (this.screenData) {
        data = Object.assign(data, this.screenData)
      }
      if (!this.$store.state.highSearch) {
        delete data.s
      }
      this.fieldDataParams = data
      localStorage.setItem('fieldDataParams', JSON.stringify(data))
      await search(data)
        .then(async res => {
          if (!checkReplacePath(this, res, 0, data, 'fieldData')) {
            // 如果没有跳走就返回进来操作
            this.loading2 = false
            if (!res.typedata.length) {
              res.typedata = [{}]
            }
            this.fieldData = res
            this.keys()
            await this.fieldData.data.obj.forEach(async (item, index) => {
              this.fieldData.data.obj[index].keywordList = item.keyword.split(
                ';'
              )
              // var avatar = ''
              this.setAvatar(item, index).then(res => {
                // item.avatar = res
                this.fieldData.data.obj[index].avatar = res
              })
              // this.fieldData.data.obj[index].avatar = avatar

              if (
                item.avatarUrl === null ||
                item.avatarUrl === ' ' ||
                item.avatarUrl === undefined
              ) {
                this.fieldData.data.obj[index].avatarUrl = ''
              }
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    // 设置检索到条数文字
    setTip () {
      this.intercept = false
      if (this.index === 1) {
        if (this.user) {
          if (this.pageData.PageIndex === 100) {
            this.intercept = true
          }
        } else {
          if (this.pageData.PageIndex === 10) {
            this.intercept = true
          }
        }
      } else if (this.index === 2) {
        if (this.user) {
          if (this.pageData.PageIndex === 400) {
            this.intercept = true
          }
        } else {
          if (this.pageData.PageIndex === 40) {
            this.intercept = true
          }
        }
      }
    },
    // 其他检索类型
    othertype () {
      let data = this.k
      this.$router.push({
        name: 'Loading',
        params: { data: data, searchtype: this.fieldData.typedata[0].othertype }
      })
    },
    // 跳转详情页
    goDetail (index) {
      let data = this.fieldData.data.obj[index]
      let query = {}
      if (/^\d+$/.test(data.kId)) {
        query.kId = data.kId
      } else {
        query.name = data.name
        query.institute = data.institute || data.organization
      }
      if (Object.keys(this.screenData).length) {
        if (!this.screenData.ks.length) {
          if (this.keyTr) {
            query.keyword = this.keyCn
          }
        }
      } else {
        query.keyword = this.keyCn
      }
      query.k = this.fieldDataParams.queryk
        ? this.fieldDataParams.queryk.join(' ')
        : this.fieldDataParams.k
      if (query.keyword == query.k) {
        delete query.k
      } else {
        query.keyword = query.k
        delete query.k
      }
      debugger
      localStorage.setItem('val', query.keyword)
      let routeData = this.$router.resolve({ name: 'Detail', query: query })
      window.open(routeData.href, '_blank')
      // this.$router.push({ name: 'Detail', query: query })
    },
    // 相识关键词翻译
    translation () {
      let list = this.simkeywordsList.slice(0, 5)
      let acqKeywords = []
      list.forEach(element => {
        getKeywordTranslate({ k: element.name })
          .then(res => {
            acqKeywords.push({
              keyCn: res.data.data[0].keyCn,
              keyEn: res.data.data[0].keyEn,
              keyCount: res.data.data[0].keyCount
            })
          })
          .catch(err => {
            console.log(err)
          })
      })
      this.acqKeywords = acqKeywords
      this.loading4 = false
    },
    // 点击相识关键词进行跳转
    simkeySearch (name) {
      localStorage.setItem('val', name)
      this.$router.push({ name: 'Loading', params: { data: name } })
    }
  }
}
</script>

<style lang="scss">
.cup{
  cursor: pointer;
}
.retrievalField {
  .meaning {
    height: 40px;
    width: 92vw;
    background: #fff;
    margin-bottom: 40px;
    .mean {
      padding-left: 40px;
      height: 40px;
      display: flex;
      align-items: center;
    }
  }
  .search-simkeyword {
    background: #fff;
    padding: 1rem;
    margin-bottom: 40px;
    .simkeyword {
      background: 0 0;
      color: #5983a9;
      margin: 1rem;
      font-weight: 600;
      cursor: pointer;
    }
  }
  .info {
    background: #fff;
    width: 92vw;
    border-top: 2px solid #000;
    padding: 1vw;

    .info-header {
      padding-left: 20px;
    }
    .info-details {
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      .info-chart {
        height: 50vh;
        margin-right: 2%;
        width: 30%;
      }
    }
  }
  .center {
    margin-bottom: 20px;
    width: 92vw;
    display: flex;
    flex-direction: row;
    .experts {
      width: 69%;
      background: #fff;
      border-top: 2px solid #000;
      padding-bottom: 20px;
      .experts-header {
        display: flex;
        align-items: center;
        height: 40px;
        margin: 20px 0 0 20px;
        img {
          margin-right: 10px;
          width: 20px;
          height: 20px;
        }
      }
      .search-r {
        width: 100%;
        .menu {
          padding: 1em;
          margin-bottom: 15px;
          h4 {
            float: left;
            font-size: 14px;
          }
          .showway {
            float: right;
            span {
              font-size: 12px;
              font-weight: 600;
              vertical-align: text-top;
            }
            img {
              display: inline-block;
              width: 20px;
              height: 20px;
              cursor: pointer;
              margin-left: 5px;
            }
          }
        }
        .res-list {
          margin-left: 3%;
          .exp-box {
            float: left;
            margin-right: 1%;
            margin-bottom: 15px;
            border: 1px #ccc solid;
            padding: 10px;
            .exp-int {
              cursor: pointer;
              display: flex;
              flex-direction: row;
              .exp-header {
                float: left;
                img {
                  display: block;
                  height: 100px;
                  width: 80px;
                }
              }
              .exp-textint {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-left: 10px;
                font-size: 12px;
                h5 {
                  margin-bottom: 10px;
                  cursor: pointer;
                }
                p {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  margin-bottom: 5px;
                }
              }
            }
            .isni {
              font-size: 12px;
              margin-top: 10px;
              min-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .subject {
              min-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 12px;
            }
            .keywords {
              height: 44px;
              overflow: hidden;
              background-color: #f5f5f5;
              margin-top: 5px;
              li {
                height: 20px;
                float: left;
                border: 1px #ccc solid;
                padding: 1px 2px;
                border-radius: 4px;
                font-size: 12px;
                margin: 0 4px 2px 0;
              }
            }
          }
        }
        .res-listelse {
          ul {
            li {
              ::-webkit-scrollbar {
                width: 6px;
                background-color: #f2f2f2;
              }
              ::-webkit-scrollbar-thumb {
                background-color: #dedede;
              }
              height: 240px;
              border: 1px #ccc solid;
              padding: 20px;
              margin-bottom: 10px;
              .eles-info {
                display: flex;
                flex-direction: row;
                .else-header {
                  cursor: pointer;
                  float: left;
                  img {
                    display: block;
                    width: 120px;
                    height: 160px;
                    margin-right: 15px;
                  }
                }
                .else-int {
                  float: left;
                  margin-right: 15px;
                  h5 {
                    font-size: 14px;
                  }
                  p {
                    width: 300px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 12px;
                    margin-top: 10px;
                  }
                  .else-keywords {
                    width: 300px;
                    height: 48px;
                    overflow: hidden;
                    margin-top: 10px;
                    span,
                    a {
                      font-size: 12px;
                    }
                    a {
                      height: 20px;
                      margin: 0 5px 4px 0;
                      display: inline-block;
                      border: 1px #ccc solid;
                      padding: 2px 4px;
                      border-radius: 4px;
                    }
                  }
                }
              }
              .else-chart {
                margin-top: 30px;
              }
              .elseinttext {
                float: left;
                width: 60%;
                font-size: 12px;
                overflow: auto;
                height: 200px;
                text-indent: 2em;
                .elseinttext-item {
                  border: none;
                  margin-bottom: 0;
                  height: 200px;
                }
              }
            }
          }
        }
      }
    }
    .institutions {
      margin-top: 20px;

      .institutions-header {
        display: flex;
        align-items: center;
        height: 40px;
        margin-left: 30px;
        img {
          margin-right: 10px;
          width: 20px;
          height: 20px;
        }
      }
      .org-list {
        font-size: 0.85em;
        font-weight: 600;
        .ret-h3 {
          margin: 1em 0;
          margin-left: 30px;
        }
        .res-list {
          margin-top: 20px;
          width: 100%;
          li {
            float: left;
            width: 32%;
            margin-right: 1%;
            margin-bottom: 1%;
            border: 1px #ccc solid;
            padding: 10px;
            .list-t {
              margin-bottom: 15px;
              img {
                float: left;
                width: 100%;
                height: 40%;
              }
              .list-t-r {
                span {
                  &:nth-child(2) {
                    margin-left: 3px;
                  }
                }
              }
            }
            .list-b {
              p {
                float: left;
                margin-top: 10px;
              }
              .list-b-button {
                float: right;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/RetrieveField.vue